
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.635.046a.804.804 0 00-1.021.475l-.963 2.653a.873.873 0 00.7 1.154l2.726.432a.797.797 0 00.917-.645.783.783 0 00-.661-.897l-.453-.072c2.342-.671 4.337-.19 5.792.896 1.814 1.353 2.894 3.723 2.71 6.303-.34 4.77-5.398 7.475-10.443 5.393a.806.806 0 00-1.048.416.775.775 0 00.426 1.023c5.836 2.409 12.227-.661 12.659-6.723.218-3.054-1.053-5.952-3.335-7.654-2.03-1.514-4.779-2.023-7.81-.961l.289-.796a.777.777 0 00-.485-.997z"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M5.403 5.627a.907.907 0 00-1.262 0L.26 9.42a.86.86 0 000 1.235l3.88 3.792c.352.34.91.34 1.262 0l3.88-3.792a.86.86 0 000-1.235zm-.63 1.593l2.881 2.817-2.882 2.817-2.882-2.817z"}})])
          )
        }
      }
    